import { gql } from '@apollo/client';
import { graphql } from 'gatsby';

export const FRAGMENT = graphql`
  fragment bb_Product_fullName on Bottlebooks_Product {
    ... on Bottlebooks_Wine {
      fullName: name(includeProducer: AUTO, nonVintage: "")
    }
    ... on Bottlebooks_Beer {
      fullName: name(includeProducer: AUTO)
    }
    ... on Bottlebooks_Spirit {
      fullName: name(includeProducer: AUTO)
    }
    ... on Bottlebooks_Cider {
      fullName: name(includeProducer: AUTO)
    }
  }
`;

const Product_fullName = {
  fragment: gql`
    fragment Product_fullName on Product {
      ... on Wine {
        fullName: name(includeProducer: AUTO, nonVintage: "")
      }
      ... on Beer {
        fullName: name(includeProducer: AUTO)
      }
      ... on Spirit {
        fullName: name(includeProducer: AUTO)
      }
      ... on Cider {
        fullName: name(includeProducer: AUTO)
      }
    }
  `,
};

export default Product_fullName;
